import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../../api/api";
import {
  QUERY_ONBOARDING_KEY,
  COMPLETE_ONBOARDING,
  ME_QUERY_KEY,
} from "../../../api/queryKeys";

export default function useCompleteOnboarding() {
  const queryClient = useQueryClient();
  return useMutation(
    () => api.post(COMPLETE_ONBOARDING).then((res) => res.data),
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries([ME_QUERY_KEY]);
        queryClient.invalidateQueries([QUERY_ONBOARDING_KEY]);
      },
    }
  );
}
